import React from 'react'
import PropTypes from 'prop-types'
import {Text, Img} from '@chakra-ui/react'

const SupplierLogo = ({logo, name}) =>
  logo ? (
    <Img src={logo} alt={name} width={200} mr={4} />
  ) : (
    <Text width={200} mr={4}>
      {name}
    </Text>
  )

SupplierLogo.defaultProps = {
  logo: null,
}

SupplierLogo.propTypes = {
  logo: PropTypes.string,
  name: PropTypes.string.isRequired,
}

export default SupplierLogo
